// extracted by mini-css-extract-plugin
export var askAiIcon = "_n8-9";
export var container = "_n8-0";
export var groupSeparator = "_n8-a";
export var highlight = "_n8-4";
export var resultIcon = "_n8-5";
export var resultItem = "_n8-7";
export var resultSubtitle = "_n8-3";
export var resultTitle = "_n8-2";
export var resultsList = "_n8-1";
export var searchGroup = "_n8-6";
export var selected = "_n8-8";